import { Form } from 'antd';
import type React from 'react';
import { AttachmentEntry } from './AttachmentEntry.tsx';
import type { AttachmentNumber } from './News.tsx';
import { UploadButton, type UploadResult } from './UploadButton.tsx';

export const AttachmentFormItem: React.FC<{
  labId: string;
  number: AttachmentNumber;
  attachmentId: string | null | undefined;
  filename: string;
  size: number;
  onSuccess: (result: UploadResult) => void;
  onPreview: () => void;
  onDelete: () => void;
}> = ({ labId, number, attachmentId, filename, size, onPreview, onDelete, onSuccess }) => {
  return (
    <Form.Item label={`Anhang ${number}`}>
      {attachmentId ? (
        <AttachmentEntry filename={filename} size={size} onPreview={onPreview} onDelete={onDelete} />
      ) : (
        <UploadButton labId={labId} number={number} onSuccess={onSuccess} />
      )}
    </Form.Item>
  );
};
